"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Route;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _signinUrl = _interopRequireWildcard(require("../util/signinUrl"));
var _excluded = ["component", "location"],
  _excluded2 = ["isAnonymous", "shouldManageFocusOnRouteChange", "isForcedSignOut"],
  _excluded3 = ["component"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function routeStateSelector(_ref) {
  var baseUrl = _ref.baseUrl,
    isLoggedIn = _ref.userPrefs.isLoggedIn;
  return {
    baseUrl: baseUrl,
    isLoggedIn: isLoggedIn
  };
}
function RedirectToSignIn(_ref2) {
  var baseUrl = _ref2.baseUrl,
    to = _ref2.to;
  _react.default.useEffect(function () {
    var targetUrl = to ? "?targetURL=".concat(encodeURI(to)) : '';
    (0, _signinUrl.redirectToSignin)(baseUrl, targetUrl);
  }, []);
  return null;
}
function RouteWrapper(_ref3) {
  var Component = _ref3.component,
    location = _ref3.location,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var isAnonymous = rest.isAnonymous,
    _rest$shouldManageFoc = rest.shouldManageFocusOnRouteChange,
    shouldManageFocusOnRouteChange = _rest$shouldManageFoc === void 0 ? true : _rest$shouldManageFoc,
    isForcedSignOut = rest.isForcedSignOut,
    routeProps = _objectWithoutProperties(rest, _excluded2);
  var _useSelector = (0, _reactRedux.useSelector)(routeStateSelector),
    isLoggedIn = _useSelector.isLoggedIn,
    baseUrl = _useSelector.baseUrl;
  var signinUrl = (0, _signinUrl.default)(baseUrl).toLowerCase();
  var currentPath = location === null || location === void 0 ? void 0 : location.pathname;
  var isSignIn = signinUrl === currentPath;
  var isRedirect = isForcedSignOut || !isAnonymous && !isLoggedIn;
  _react.default.useEffect(function () {
    var nuiContentContainer = document.getElementById('nuiContentContainer');
    if (nuiContentContainer && shouldManageFocusOnRouteChange) {
      document.getElementById('nullSpan').focus();
    }
  }, [shouldManageFocusOnRouteChange]);
  return isRedirect && !isSignIn ? /*#__PURE__*/_react.default.createElement(RedirectToSignIn, {
    baseUrl: baseUrl,
    to: location === null || location === void 0 ? void 0 : location.pathname
  }) : /*#__PURE__*/_react.default.createElement(Component, routeProps);
}
function Route(_ref4) {
  var component = _ref4.component,
    rest = _objectWithoutProperties(_ref4, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
    render: function render(routeProps) {
      return /*#__PURE__*/_react.default.createElement(RouteWrapper, _extends({
        component: component
      }, rest, routeProps));
    }
  }));
}